import { Checkbox, FormControlLabel } from "@mui/material";
import { type FC } from "react";

import { CheckboxIcon } from "@shared/frontend/icons";
import clsx from "clsx";
import "./TwoCheckbox.scss";

interface TwoCheckboxProps {
  isChecked: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  text?: string;
  labelClassName?: string;
  yesOptionText?: string;
  noOptionText?: string;
}

export const TwoCheckbox: FC<TwoCheckboxProps> = ({
  isChecked,
  text = "",
  handleChange,
  labelClassName,
  yesOptionText = "כן",
  noOptionText = "לא",
}) => {
  return (
    <div className="two-checkbox-container">
      <p className={clsx("checkbox-label", labelClassName)}>{text}</p>
      <div className="checkbox-container">
        <FormControlLabel
          control={
            <Checkbox
              checkedIcon={<CheckboxIcon checked />}
              icon={<CheckboxIcon />}
              name="yes"
              onChange={(e) => handleChange(e)}
            />
          }
          label={yesOptionText}
          checked={isChecked}
        />
        <div className="line" />
        <FormControlLabel
          control={
            <Checkbox
              name="no"
              checkedIcon={<CheckboxIcon checked />}
              icon={<CheckboxIcon />}
              onChange={(e) => handleChange(e)}
            />
          }
          label={noOptionText}
          checked={!isChecked}
        />
      </div>
    </div>
  );
};
